import createAPI from '../axios'

// 教学评价服务 API
const evaluateManage = {
    questionnaireServer: {
        type: config => createAPI('/evaluateManage/questionnaireServer/type', 'post', config),
        finishedQue: config => createAPI('/evaluateManage/questionnaireServer/finishedQue', 'post', config),
        createEvaluate: config => createAPI('/evaluateManage/questionnaireServer/createEvaluate', 'post', config),
        pjxData: config => createAPI('/evaluateManage/questionnaireServer/pjxData', 'post', config),

        // 听课表
        tkTeaCombo: config => createAPI('/evaluateManage/questionnaireServer/tkTeaCombo', 'post', config),
        tkQueryCourse: config => createAPI('/evaluateManage/questionnaireServer/tkQueryCourse', 'post', config),
        tkCourseCombo: config => createAPI('/evaluateManage/questionnaireServer/tkCourseCombo', 'post', config),
        tkSzxb: config => createAPI('/evaluateManage/questionnaireServer/tkSzxb', 'post', config),
        tkTkbjCombo: config => createAPI('/evaluateManage/questionnaireServer/tkTkbjCombo', 'post', config),
        tkTkddCombo: config => createAPI('/evaluateManage/questionnaireServer/tkTkddCombo', 'post', config),
        tkJcInfo: config => createAPI('/evaluateManage/questionnaireServer/tkJcInfo', 'post', config),
        subTkForm: config => createAPI('/evaluateManage/questionnaireServer/subTkForm', 'post', config),
        tkYdxss: config => createAPI('/evaluateManage/questionnaireServer/tkYdxss', 'post', config),
        openTkQue: config => createAPI('/evaluateManage/questionnaireServer/openTkQue', 'post', config),
        loadWtjInfo: config => createAPI('/evaluateManage/questionnaireServer/loadWtjInfo', 'post', config),

        // 学生表
        stuTeaData: config => createAPI('/evaluateManage/questionnaireServer/stuTeaData', 'post', config),
        className: config => createAPI('/evaluateManage/questionnaireServer/className', 'post', config),
        subStuEvaluate: config => createAPI('/evaluateManage/questionnaireServer/subStuEvaluate', 'post', config),
        class: config => createAPI('/evaluateManage/questionnaireServer/class', 'post', config),
        openStuQue: config => createAPI('/evaluateManage/questionnaireServer/openStuQue', 'post', config),
        //系主任
        xzrTeaData: config => createAPI('/evaluateManage/questionnaireServer/xzrTeaData', 'post', config),
        subXzrEvaluate: config => createAPI('/evaluateManage/questionnaireServer/subXzrEvaluate', 'post', config),
        openXzrQue: config => createAPI('/evaluateManage/questionnaireServer/openXzrQue', 'post', config),

        //听课记录表
        openTkGgZyQue: config => createAPI('/evaluateManage/questionnaireServer/openTkGgZyQue', 'post', config),
        tkGgTeaCombo: config => createAPI('/evaluateManage/questionnaireServer/tkGgTeaCombo', 'post', config),
        tkGgCourseCombo: config => createAPI('/evaluateManage/questionnaireServer/tkGgCourseCombo', 'post', config),
        subTkGgForm: config => createAPI('/evaluateManage/questionnaireServer/subTkGgForm', 'post', config),
        loadClassSite: config => createAPI('/evaluateManage/questionnaireServer/loadClassSite', 'post', config),
        tkZyCourseCombo: config => createAPI('/evaluateManage/questionnaireServer/tkZyCourseCombo', 'post', config),

        //总览
        queryList: config => createAPI('/evaluateManage/questionnaireServer/queryList', 'post', config),
        details: config => createAPI('/evaluateManage/questionnaireServer/details', 'post', config),
        tkCombo: config => createAPI('/evaluateManage/questionnaireServer/tkCombo', 'post', config),
    },
    //题目设置
    questionSet: {
        queryList: config => createAPI('/evaluateManage/questionSet/queryList', 'post', config),

        addSaveXzt: config => createAPI('/evaluateManage/questionSet/addSaveXzt', 'post', config),

        delMod: config => createAPI('/evaluateManage/questionSet/delMod', 'post', config),

        editSave: config => createAPI('/evaluateManage/questionSet/editSave', 'post', config),

        queryXztOption: config => createAPI('/evaluateManage/questionSet/queryXztOption', 'post', config),

        addOptionSave: config => createAPI('/evaluateManage/questionSet/addOptionSave', 'post', config),

        delOption: config => createAPI('/evaluateManage/questionSet/delOption', 'post', config),

        addOptionUpd: config => createAPI('/evaluateManage/questionSet/addOptionUpd', 'post', config),
    },
    //问卷设置
    questionnaireSet: {
        queryList: config => createAPI('/evaluateManage/questionnaireSet/queryList', 'post', config),

        save: config => createAPI('/evaluateManage/questionnaireSet/save', 'post', config),

        del: config => createAPI('/evaluateManage/questionnaireSet/del', 'post', config),

        copy: config => createAPI('/evaluateManage/questionnaireSet/copy', 'post', config),

        queryQuestionTableList: config => createAPI('/evaluateManage/questionnaireSet/queryQuestionTableList', 'post', config),

        queryQuestionList: config => createAPI('/evaluateManage/questionnaireSet/queryQuestionList', 'post', config),

        addQuestion: config => createAPI('/evaluateManage/questionnaireSet/addQuestion', 'post', config),

        delQuestion: config => createAPI('/evaluateManage/questionnaireSet/delQuestion', 'post', config),

        questionUp: config => createAPI('/evaluateManage/questionnaireSet/questionUp', 'post', config),

        questionDown: config => createAPI('/evaluateManage/questionnaireSet/questionDown', 'post', config),
    },
    //问卷情况
    situation: {
        queryList: config => createAPI('/evaluateManage/situation/queryList', 'post', config),

        querySituationList: config => createAPI('/evaluateManage/situation/querySituationList', 'post', config),

        loadDetail: config => createAPI('/evaluateManage/situation/loadDetail', 'post', config),

        initData: config => createAPI('/evaluateManage/situation/initData', 'post', config),

        loadQuestionnaireCombo: config => createAPI('/evaluateManage/situation/loadQuestionnaireCombo', 'post', config),

        loadResetClassCombo: config => createAPI('/evaluateManage/situation/loadResetClassCombo', 'post', config),

        loadResetStuCombo: config => createAPI('/evaluateManage/situation/loadResetStuCombo', 'post', config),

        reset: config => createAPI('/evaluateManage/situation/reset', 'post', config),
    },
    //问卷调查
    questionnaireSurvey: {
        initData: config => createAPI('/evaluateManage/questionnaireSurvey/initData', 'post', config),

        queryList: config => createAPI('/evaluateManage/questionnaireSurvey/queryList', 'post', config),

        loadInfo: config => createAPI('/evaluateManage/questionnaireSurvey/loadInfo', 'post', config),

        loadStatistics: config => createAPI('/evaluateManage/questionnaireSurvey/loadStatistics', 'post', config),

        submit: config => createAPI('/evaluateManage/questionnaireSurvey/submit', 'post', config),

        exportFile: config => createAPI('/evaluateManage/questionnaireSurvey/exportFile', 'post', config),
    },
    
    //评教时间管理
    questionnaireTime: {
        initCombo: config => createAPI('/evaluateManage/questionnaireTime/initCombo', 'post', config),
    
        queryList: config => createAPI('/evaluateManage/questionnaireTime/queryList', 'post', config),
    
        save: config => createAPI('/evaluateManage/questionnaireTime/save', 'post', config),
    },
};

export default evaluateManage;



// WEBPACK FOOTER //
// ./src/api/modules/evaluateManage.js